import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { vp } from '@/tools/helpers'
import { showServerValidationErrors } from '@/tools/validator'

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_BACKEND
Vue.axios.defaults.headers = { 'X-Requested-With': 'XMLHttpRequest' }

Vue.axios.interceptors.response.use((response) => { // intercept the global error
  if (response.data && response.data.status === 'success' && response.data.msg) {
    vp.$notify.success(response.data.msg)
  }

  return response
}, (error) => {
  // if ((!error.response && error.config) || (error.response && error.response.status === 401)) {
  //   // Vue.auth.logout({ makeRequest: false })
  //   vp.$notify.error('You are not authorized to access this resource')
  // }
  if (!error.response && error.config) {
    vp.$notify.error('The server has encountered an unexpected error. If the problem persists, please contact an administrator')
  }
  if ((error.response && error.response.status === 401)) {
    Vue.auth.logout({ makeRequest: false })
    vp.$notify.error('You are not authorized to access this resource')
  }
	// if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
	// 	Vue.auth.logout({ makeRequest: false })
	// }
  if (error.response && error.response.status === 422 && error.response.data) {
    showServerValidationErrors(error.response.data)//
  } else if (error.response && error.response.data) {
    vp.$notify.error(error.response.data.msg)
  }
  return Promise.reject(error)
})
